import { achievementConfiguration } from '@/constants/reward.js';

export const getAchievementNameTranslationKey = (achievementName) => `achievement_name_${ achievementName }`;

export const getAchievementBadgeImage = (achievementName) => achievementConfiguration[achievementName]?.image || '';

export const calculateAchievementTotalCompleted = (totalItems, percentageCompleted) => Math.ceil((totalItems * percentageCompleted) / 100);

export const getLevelNameTranslationKey = (level) => `level_name_LEVEL_${ level }`;

export const getLevelBadgeImage = (level) => `/static/images/achievements/level_${ level }.svg`;

export const getLevelNumberImage = (level) => `/static/images/levels_numb/lvl${ level }.svg`;

export const getLevelCompletedImage = (level) => `/static/images/levels/levelup_${ level }.svg`;

export const calculateLevelCompletedPercentage = (isCompleted, totalCompleted, totalThreshold) => {
  if (isCompleted) {
    return 100;
  } else if (totalThreshold > 0) {
    return (totalCompleted / totalThreshold) * 100;
  } else {
    return 0;
  }
};
